import React, { useState } from "react";
import { FormSectionElements, FormSections } from "src/entities/formTemplateDataType";
import { getRootComponent } from "../../utilities/ElementUtils";
import { ConfirmDialog } from "primereact/confirmdialog";


type Props = {
    isEng: boolean;
    field: FormSectionElements;
    callback;
}

const DeleteSubsectionButtonComponent = ({isEng, field, callback}: Props) => {
    const [showDialog, setShowDialog] = useState(false);
    const subsec = field.parent;
    const section = subsec.parent as FormSections;
    const subsectionWithDuplicate = (): boolean => {
        if (subsec.IsDuplicate) return true;
        let result = false;
        const section = subsec.parent as FormSections;
        section.ListOfFormSubSections.forEach(s => {
            if (s.ENUTitle == subsec.ENUTitle && s.IsDuplicate) result = true;
        })
        return result;
    }

    if (!subsectionWithDuplicate()) return null;
    const deleteSubsection = () => {

       if (field.EventScript) {
            const customJSFunc = eval(`(${field.EventScript})`);
            customJSFunc(field);
        }

        let programContainer = getRootComponent(field);
        const subsecIndex = section.ListOfFormSubSections.findIndex(s => s == subsec);
        if (subsec.IsDuplicate) section.ListOfFormSubSections.splice(subsecIndex, 1);
        else {
            section.ListOfFormSubSections.splice(subsecIndex, 1);
            section.ListOfFormSubSections[subsecIndex].IsDuplicate = false;
        }
         
        callback(programContainer);
        setShowDialog(false);
}

const handleClick = () => {
        if (!field.ShowPopup) {
            deleteSubsection();
        } else {
            setShowDialog(true); // show the ConfirmDialog
        }
    };

    return(
<>
            <button
                type="button"
                className="ontario-button ontario-button--tertiary"
                onClick={handleClick}
            >
                {isEng ? field.ENUTitle : field.FRATitle}
            </button>
            
            {/* Render confirmation dialog only if ShowPopup is enabled */}
            {field.ShowPopup && (
                
                <ConfirmDialog
                    className="dialog-style"
                    visible={showDialog}
                    header={isEng ? field.PopupTitle || field.PopupDialogConfigs?.PopupTitle : field.PopupTitleFRA || field.PopupDialogConfigs?.PopupTitleFRA}
                    message={isEng ? field.PopupMessage || field.PopupDialogConfigs?.PopupMessage : field.PopupMessageFRA || field.PopupDialogConfigs?.PopupMessageFRA}
                    closable={field.PopupDialogConfigs?.PopupCloseable || false}
                    acceptLabel={isEng ? field.PopupSaveButtonText || field.PopupDialogConfigs?.PopupRightButtonText : field.PopupSaveButtonTextFRA || field.PopupDialogConfigs?.PopupRightButtonTextFRA}
                    rejectLabel={isEng ? field.PopupCancelButtonText || field.PopupDialogConfigs?.PopupLeftButtonText : field.PopupCancelButtonTextFRA || field.PopupDialogConfigs?.PopupLeftButtonTextFRA}
                    acceptClassName={field.PopupDialogConfigs?.PopupRightButtonClassName || "ontario-button ontario-button--tertiary"}
                    rejectClassName={field.PopupDialogConfigs?.PopupLeftButtonClassName || "ontario-button ontario-button--primary"}
                    accept={() => setShowDialog(false)}
                    reject={deleteSubsection}
                    onHide={() => setShowDialog(false)}
                />
                
            )}
        </>
    );
}

export default DeleteSubsectionButtonComponent;